import { returnPath } from '~/features/common/utils/navigation/returnPath';


export const getIndexPath = returnPath("/templates/lap-sequence");
export const getIdPath = returnPath("/templates/lap-sequence/:id");